import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamFlowsQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamFlowsQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset:
  Int!,
  $orderBy: FlowSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragment
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
